export function indent(str: string, count: number): string {
    const indentStr = new Array(count * 2).fill(" ").join("");
    return str
        .split("\n")
        .map(x => {
            if (x === "") {
                return x;
            }
            return indentStr + x;
        })
        .join("\n");
}
